import SectionComponent from './Section.vue';
export const Section = SectionComponent;
export default Section;
